import { S143gS143m01Component } from './s143g-s143m01.component';

export { S143gModule } from './s143g.module';

export const S143gSubComponentsMap = {
	
};

export const S143gComponentsMap = {
	"s143g-s143m01": S143gS143m01Component
};

export const S143gComponents = [
	S143gS143m01Component
];

